import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, subtitle, children, testid }) {
  return (
    <div className="App relative min-h-screen bg-[#050505]" data-testid={testid}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12 pt-32 pb-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/60 hover:text-[#D4AF37] transition-colors"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> Zurück zur Startseite
        </Link>

        <div className="mt-10 mb-12">
          <span className="overline">Rechtliches</span>
          <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-white/60 text-base sm:text-lg font-light">
              {subtitle}
            </p>
          )}
          <div className="mt-8 gold-line max-w-xs" />
        </div>

        <article className="prose-legal text-white/75 font-light leading-relaxed space-y-8">
          {children}
        </article>
      </div>
    </div>
  );
}
